import { render } from "./SelectField.vue?vue&type=template&id=10ea4958"
import script from "./SelectField.vue?vue&type=script&lang=js"
export * from "./SelectField.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SelectField.vue"]])

export default __exports__